import type { PropType } from "data/types"

const allLinks: string = "to?: string\nhref?: string"
const blank: string = `${allLinks}\nblank?: boolean`
const allLinksClickBlank: string = `${blank}\nonClick?: () => void`

export const allProps: PropType[] = [
    {
        name: "AccordionItemProps",
        component: "Accordion",
        content: "title: string\nisOpen?: boolean\ncontent: string | ReactNode",
    },
    {
        name: "BreadcrumbsItemProps",
        component: "Breadcrumbs",
        content: `text: string\n${allLinks}`,
    },
    {
        name: "MessageProps",
        component: "Messaging",
        content:
            'type: "received" | "sent"\ntext: string\ndate?: string\ntime?: string',
    },
    {
        name: "TabsItemProps",
        component: "Tabs",
        content: "title: string\ncontent: string | ReactNode",
    },
    {
        name: "StepProps",
        component: "Stepper",
        content: `text: string\n${blank}`,
    },
    {
        name: "DropdownItemProps",
        component: "Dropdown",
        content: `text: string\nicon?: string\n${allLinksClickBlank}`,
    },
    {
        name: "FooterItemProps",
        component: "Footer",
        content: `content: string | JSX.Element\n${allLinksClickBlank}`,
    },
    {
        name: "ButtonGroupProps",
        component: "ButtonGroup",
        content: `"aria-label"?: string\ntext: string\niconLeft?: string\niconRight?: string\niconOnly?: string\n${allLinksClickBlank}`,
    },
    {
        name: "ListGroupItemProps",
        component: "ListGroup",
        content: `text: string\nsubtext?: string\nbadge?:\n    | true\n    | { icon?: string; number?: number; color?: ColorsShortTypes }\ndate?: string | Date\n${allLinksClickBlank}\ndisabled?: boolean`,
    },
    {
        name: "IconMenuItemProps",
        component: "IconMenu",
        content: `icon: string\nlabel: string\n${allLinksClickBlank}`,
    },
    {
        name: "BaseUseFormType",
        component: "useForm hook",
        content:
            "handleInputs: (e: ChangeEvent<HTMLInputElement>) => void\nresetForm: () => void\nhandleSubmit: (e: ChangeEvent<HTMLFormElement>) => void",
    },
]
